import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/global.scss';
import AppLayout from './components/Layout/AppLayout';
import Dashboard from './pages/Dashboard';
import Incidents from './pages/Incidents';
import Reports from './pages/Reports';
import Configuration from './pages/Configuration';
import CustomerRequests from './pages/CustomerRequests';
import SystemAdmin from './pages/SystemAdmin';
import PlaybookAutomation from './pages/PlaybookAutomation';
import DetectionRules from './pages/DetectionRules';
import KnowledgeBase from './pages/KnowledgeBase';
import SignInPage from './pages/Auth/SignInPage';
import { SignedIn, SignedOut } from '@clerk/clerk-react';
import PermissionInitializer from './components/PermissionInitializer';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signin" element={<SignInPage />} />
        <Route
          path="/*"
          element={
            <>
              <SignedOut>
                <Navigate to="/signin" replace />
              </SignedOut>
              <SignedIn>
                {/* PermissionInitializer fetches permissions ONCE on login */}
                <PermissionInitializer>
                  <Routes>
                    <Route element={<AppLayout />}> 
                      <Route index element={<Dashboard />} />
                      <Route path="incidents" element={<Incidents />} />
                      <Route path="incidents/:incidentId" element={<Incidents />} />
                      <Route path="reports" element={<Reports />} />
                      <Route path="configuration" element={<Navigate to="/configuration/general" replace />} />
                      <Route path="configuration/:tab" element={<Configuration />} />
                      <Route path="customer-requests" element={<CustomerRequests />} />
                      <Route path="customer-requests/:requestId" element={<CustomerRequests />} />
                      <Route path="system-admin" element={<Navigate to="/system-admin/users" replace />} />
                      <Route path="system-admin/:tab" element={<SystemAdmin />} />
                      <Route path="detection-rules" element={<DetectionRules />} />
                      <Route path="playbook-automation" element={<Navigate to="/playbook-automation/templates" replace />} />
                      <Route path="playbook-automation/:tab" element={<PlaybookAutomation />} />
                      <Route path="knowledge" element={<KnowledgeBase />} />
                    </Route>
                  </Routes>
                </PermissionInitializer>
              </SignedIn>
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
